// /Redux/Slices/ui-slice.ts
import { DomainRedux, DomainType } from '@/Shared';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type DeviceType = 'mobile' | 'desktop';

interface UIState {
    sidebarOpen: boolean;
    pageTitle: string | null;
    lastRoute: string | null;
    deviceType: DeviceType;
    totalItems : number | null;
    badges: Record<DomainRedux, number[]>;
    activeDomainDetail ? : DomainType | null,
    trashMode : boolean,
}

const initialState: UIState = {
    sidebarOpen: true,
    pageTitle: null,
    lastRoute: null,
    deviceType: 'desktop',
    totalItems : null,
    badges: {} as Record<DomainRedux, number[]>,
    activeDomainDetail  : null,
    trashMode : false
};

const uiStateSlice = createSlice({
    name: 'uiState',
    initialState,
    reducers: {

        // Sidebar
        toggleSidebar(state) {
            state.sidebarOpen = !state.sidebarOpen;
        },
        setSidebarOpen(state, action: PayloadAction<boolean>) {
            state.sidebarOpen = action.payload;
        },
        setTotalItems(state, action: PayloadAction<number|null>) {
            state.totalItems = action.payload;
        },

        // Content
        setPageTitle(state, action: PayloadAction<string | null>) {
            state.pageTitle = action.payload;
        },
        setLastRoute(state, action: PayloadAction<string | null>) {
            state.lastRoute = action.payload;
        },

        // Devices
        setDeviceType(state, action: PayloadAction<DeviceType>) {
            state.deviceType = action.payload;
        },

        // Trashes
        toggleTrashMode(state) {
            state.trashMode = !state.trashMode;
        },

        // Badges
        resetBadge(state, action: PayloadAction<DomainRedux>) {
            const key = action.payload;
            state.badges[key] = [];
        },

        removeBadge(state, action: PayloadAction<{ key: DomainRedux; values: number[] }>) {
            const {key, values} = action.payload;
            const current = state.badges[key];
            if (current && values?.length) {
                state.badges[key] = current.filter(
                id => !values.includes(id)
                );
            }
        },

        updateBadge(state, action: PayloadAction<{ key: DomainRedux; values: number[] }>) {
            const {key, values} = action.payload;
            const current = state.badges[key] ?? [];

            // merge + unicité
            state.badges[key] = Array.from(
                new Set([...current, ...values])
            );
        },

         setCurDomainType(state, action: PayloadAction<DomainType>) {
            state.activeDomainDetail  = action.payload;
        },
    },
});

export const { actions: uiStateActions, reducer: uiStateReducer } = uiStateSlice;
